import React, { useEffect, useState } from 'react'
import { buildTestTableData, TestDataTableProvider } from './virtualTableTestData'
import { VirtualTable } from '../VirtualTable'
import { FlexC, FlexR } from '../Flex'

interface TestVirtualTableProps {}

export const VirtualTableTest = React.forwardRef(function TestVirtualTable(props: TestVirtualTableProps, ref: any) {
	const [provider, setProvider] = useState(new TestDataTableProvider([]))
	useEffect(() => {
		const data = buildTestTableData()
		setProvider(new TestDataTableProvider(data))
	}, [])

	return <VirtualTable fill gap="0px" provider={provider} localStorageKey="TestTableData" />
})
